import React from 'react';
import './MobileLayoutSubPage.less';

function MobileLayoutSubPage({ children }) {
  return (
    <div className="mobile-layout-subpage">
      <div className="app-body-container">
        <div className="app-body-wrapper">
            {children}
        </div>
      </div>
    </div>
  );
}

export default MobileLayoutSubPage;
